exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tag-list-block [class~=field-text]:last-child{margin-bottom:.5rem}", ""]);

